import React from 'react'
import { Global } from '@emotion/react'
import { getColorBackgroundSelector } from './selectors'
import { ecss } from '@signal/theme/emotion'

export const SIGNAL_HIDE = 'signal-hide'

const globalStyle = ecss`
  ${props =>
    props.forOnSite
      ? `
      @font-face {
        font-family: "Source Sans Pro";
        src: url("https://cdn.purecars.com/staticcontent/fonts/SourceSansPro-Regular.ttf");
      }

      @font-face {
        font-family: "Work Sans";
        src: url("https://cdn.purecars.com/staticcontent/fonts/WorkSans-VariableFont_wght.ttf");
      }

      #pc_shadowRootChild {
        margin: 0;
        font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont,
          "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif,
          "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
      }
    `
      : `
    body {
      background-color: ${getColorBackgroundSelector()(props)};
    }
  `}
  
  .${SIGNAL_HIDE} {
    display: none !important;
  }

  @keyframes pure-spin {
    0% { transform: rotate(360deg); }
    100% { transform: rotate(0deg); }
  }
`

const GlobalStyles = () => {
  return <Global styles={globalStyle} />
}

export default GlobalStyles
